// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__kx8Ql","rows":"style_rows__TrrW6","row":"style_row__3sDsR","embeddedForms":"style_embeddedForms__3l7_y"};